import { Injectable } from '@angular/core';
import { CrudService } from '@appstrax/services/database';
import { MarketplaceListing } from '@models';

@Injectable({ providedIn: 'root' })
export class MarketplaceListingService extends CrudService<MarketplaceListing> {
  constructor() {
    super('marketplace-listings', MarketplaceListing);
  }
}

